// extracted by mini-css-extract-plugin
export default {"wrapper":"Welcome_wrapper__zYxPP","h3":"Welcome_h3__lS-U9","loginLink":"Welcome_loginLink__JUtor"};